/**
 * Jaron, 2026-10-25 (Monday 13386537666): "While people are creating a new
 * lead they need to select Smart Home, Solar etc."
 *
 * The Products picker in the Add Customer form (app `Customer.tsx`, web
 * `Customers.tsx`, both rendering the shared `CustomerInfo`) was optional, so
 * a lead could be born with `products === ''`. This rule makes picking at
 * least one of the products OFFERED for the chosen state mandatory. It only
 * runs when a lead is created; existing customers are never re-validated.
 *
 * `offered` is the value list from `useProducts('', solarCompany)` — the same
 * state-filtered options the picker shows (V52). A product left over from a
 * previously picked state that the current state does not offer does not
 * count. If nothing is offered (no state picked yet, or a tenant without a
 * state picker) there is nothing to choose from, so this rule does not block;
 * the state field's own required check covers that case.
 */
export const isNewLeadProductMissing = (
  products: string,
  offered: readonly string[],
): boolean => {
  if (offered.length === 0) return false
  const picked = products === '' ? [] : products.split(' / ')
  return !picked.some((p) => offered.includes(p))
}

/** Inline message under the Products picker, naming the offered labels. */
export const newLeadProductsMessage = (
  offeredLabels: readonly string[],
): string =>
  offeredLabels.length > 0
    ? `Select at least one product (${offeredLabels.join(
        ', ',
      )}) to create this lead.`
    : 'Select at least one product to create this lead.'
